import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { ChildrenProp } from '@/common/types_and_interfaces.ts'
import { AppRoutePaths } from '@/routing/route_paths.ts' // Adjust the import path as necessary
import { persistor } from '@/app-store/store.ts'
import { AuthService } from './AuthService'

const INACTIVITY_TIMEOUT = 60 * 60 * 1000 // 15 minutes in milliseconds // setted 60 minutes to test session timeout popup

const InactivityLogout = ({ children }: ChildrenProp) => {
  const dispatch = useDispatch()
  const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined)
  const location = useLocation()
  const auth_paths = AppRoutePaths.auth

  const skipPaths: string[] = [
    auth_paths.login,
    auth_paths.forgot_password.enter_email,
    auth_paths.forgot_password.check_email,
    auth_paths.reset_password,
    auth_paths.sign_up,
  ]
  const shouldSkipInactivityLogout = skipPaths.includes(location.pathname)

  const resetTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = setTimeout(() => {
      if (!shouldSkipInactivityLogout) {
        persistor.purge()
        AuthService.logout()
      }
    }, INACTIVITY_TIMEOUT)
  }

  useEffect(() => {
    // Add event listeners for user activity
    window.addEventListener('mousemove', resetTimer)
    window.addEventListener('keydown', resetTimer)
    window.addEventListener('click', resetTimer)
    window.addEventListener('scroll', resetTimer)
    window.addEventListener('touchstart', resetTimer)

    // Start the timer for the first time
    resetTimer()

    // Clean up event listeners and timeout on component unmount
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      window.removeEventListener('mousemove', resetTimer)
      window.removeEventListener('keydown', resetTimer)
      window.removeEventListener('click', resetTimer)
      window.removeEventListener('scroll', resetTimer)
      window.removeEventListener('touchstart', resetTimer)
    }
  }, [dispatch, location.pathname]) // Include location.pathname in dependencies

  return children
}

export default InactivityLogout
